import React from 'react';
import { motion } from 'framer-motion';

interface SugarCardProps {
  delay?: number;
}

const SugarCard: React.FC<SugarCardProps> = ({ delay = 0.5 }) => {
  return (
    <motion.div
      className="relative bg-white h-[172px] rounded-[31px] shadow-card w-[217px] overflow-hidden"
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{
        duration: 0.6,
        delay,
        type: "spring",
        stiffness: 100,
        damping: 15
      }}
      whileHover={{
        y: -5,
        transition: { duration: 0.2 }
      }}
    >
      <div className="flex h-full flex-col items-center justify-center">
        <motion.div
          className="flex items-center justify-center gap-3 w-full"
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ delay: delay + 0.2, duration: 0.3 }}
        >
          <div className="relative h-[22px] w-[140px]">
            <div className="absolute inset-0 rounded-full bg-navy-dark" />
            <div className="absolute left-0 top-0 h-full w-[45%] rounded-full bg-purple-card z-10" />
          </div>
        </motion.div>
        <motion.div
          className="mt-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: delay + 0.4, duration: 0.3 }}
        >
          <p
            className="text-purple-card text-[58px] font-bold tracking-[-2.9px] leading-none"
            style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
          >
            sugar
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default SugarCard;
